import React, { PropsWithChildren, createContext, useContext, useMemo } from 'react'
import { Styled, TStyledFlexProps } from './styled'

type TFlexProps = PropsWithChildren<TStyledFlexProps>

export const FlexContext = createContext<{ columnSpace: number; rowSpace: number; columns: number }>({
  columnSpace: 0,
  rowSpace: 0,
  columns: 0,
})

export const Flex = ({ children, ...props }: TFlexProps) => {
  const { columnSpace, rowSpace, isContainer, columns } = props
  const {
    columnSpace: contextColumnSpace,
    rowSpace: contextRowSpace,
    columns: contextColumns,
  } = useContext(FlexContext)

  const initialProps = {
    ...props,
    columnSpace: isContainer ? columnSpace : contextColumnSpace ?? columnSpace,
    rowSpace: isContainer ? rowSpace : contextRowSpace ?? rowSpace,
    columns: isContainer ? columns : contextColumns ?? columns,
  }

  const context = useMemo(
    () => ({
      columnSpace,
      rowSpace,
      columns,
    }),
    [columnSpace, rowSpace, columns]
  )

  return (
    <FlexContext.Provider value={context}>
      <Styled.StyledFlex {...initialProps}>{children}</Styled.StyledFlex>
    </FlexContext.Provider>
  )
}
